import Api from "@/services/Api";

export default {
  indexByCampaign(campaignId) {
    return Api().get("items/by_campaign/" + campaignId);
  },
  indexGrantableByCharacter(characterId) {
    return Api().get("items/grantable_by_character/" + characterId);
  },
  indexByCharacter(characterId, form) {
    return Api().post("items/by_character/" + characterId, form);
  },
  store(form) {
    return Api().post("items", form);
  },
  slots() {
    return Api().get("items/slots");
  },
  discardEffects() {
    return Api().get("items/discard_effects");
  }
};